export default "__VITE_ASSET__DllXtpQt__"